import { useLayoutEffect } from "react";
import { useLocation } from "react-router";
import { useTheme } from "@/providers/theme-provider";

/**
 * Tema dark fisso su tutte le route (marketing, auth, app). useLayoutEffect su pathname
 * sovrascrive preferenze salvate quando si cambia pagina (es. dopo il theme switch in profilo).
 */
export function AppThemeSync() {
    const { pathname } = useLocation();
    const { setTheme } = useTheme();

    useLayoutEffect(() => {
        setTheme("dark");
    }, [pathname, setTheme]);

    return null;
}
